<template>
  <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
    layout='inline'>
    <a-form-item label="" name='keyword'>
      <a-input-group compact :style="{width:'360px'}">
        <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
          <a-select-option value="dealer_name">经销商名称</a-select-option>
          <a-select-option value="dealer_sn">经销商编号</a-select-option>
        </a-select>
        <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
      </a-input-group>
    </a-form-item>
    <a-form-item label="经销商级别" name='level_id'>
      <a-select v-model:value="search.level_id" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option v-for='item in levelList' :key='item.level_id' :value="item.level_id">{{item.level_name}}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="时间筛选" name='time'>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" style="width:340px"/>
    </a-form-item>
    <a-form-item label="异常数量" name="sort">
        <a-select v-model:value="search.sort">
          <a-select-option value="DESC">从大到小排序</a-select-option>
          <a-select-option value="ASC">从小到到排序</a-select-option>
        </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <p class="p-b-20">总异常扫码数量：{{allNum}}</p>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='dealer_sn' :columns='columns' :data-source='list'>
    <template v-slot:action="{ record }">
      <a v-has:antiAuditWarningLog="()=> {$router.push('/antiFleeingGoods/marketAudit/warningDetails?type=dealer&id='+record.dealer_sn+'&name='+record.dealer_name)}"
        href="javascript:;">查看全部记录</a>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
</template>
<script>
  import { onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { getPageState } from "@/utils/pageState";
  import { getDealerLevelList } from "@/api/dealer";
  import { fleeingWarningDealer } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    level_id: '',
    page: 1,
    limit: 10,
    key_type: "dealer_name",
    keyword: "",
    sort:'DESC'
  };
  export default {
    components: {},
    setup() {
      const state = reactive({
        time: [],
        levelList: []
      });
      let columns = [
        {
          title: "经销商名称",
          dataIndex: "dealer_name",
          key: "dealer_name",
        },
        {
          title: "经销商编号",
          dataIndex: "dealer_sn",
          key: "dealer_sn",
        },
        {
          title: "经销商级别",
          dataIndex: "dealer_level_name",
          key: "dealer_level_name",
        },
        {
          title: "异常扫码数量",
          dataIndex: "scan_ex_num",
          key: "scan_ex_num",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      // 获取经销商等级
      const getLevel = async () => {
        let res = await getDealerLevelList().then(res => res.data);
        if (iscode(res)) {
          state.levelList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        allNum,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        allNum,
        pageSearchChange,
        listLoading,
      };

      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(fleeingWarningDealer, search.value);
        getLevel();
      });
      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime
      };
    },
  };
</script>